import { createReducer, on } from '@ngrx/store';

import { ProjectEntityListActions } from './project-entity-list.actions';
import { ProjectEntityListState, initialState } from './project-entity-list.state';

export const reducer = createReducer(
  initialState,
  // Query
  on(
    ProjectEntityListActions.query_entity_list_start,
    (state: ProjectEntityListState): ProjectEntityListState => ({
      ...state,
      projectEntityListError: null,
      projectEntityListLoading: true
    })
  ),
  on(ProjectEntityListActions.query_entity_list_success, (state, data): ProjectEntityListState => {
    return {
      ...state,
      projectEntityList: data.projectList.Items,
      count: data.projectList.TotalItems,
      rootActions: data.rootActions,
      projectEntityListError: null,
      projectEntityListLoading: false
    };
  }),
  on(
    ProjectEntityListActions.query_entity_list_fail,
    (state, error): ProjectEntityListState => ({
      ...state,
      projectEntityList: [],
      count: 0,
      rootActions: [],
      projectEntityListError: error,
      projectEntityListLoading: false
    })
  ),

  // Actions
  on(
    ProjectEntityListActions.delete_entity_start,
    ProjectEntityListActions.delete_entity_success,
    ProjectEntityListActions.copy_entity_start,
    ProjectEntityListActions.copy_entity_success,
    ProjectEntityListActions.import_xml_start,
    ProjectEntityListActions.import_xml_success,
    (state: ProjectEntityListState): ProjectEntityListState => ({
      ...state,
      actionError: '',
      actionErrorData: null,
      projectEntityListLoading: true
    })
  ),
  on(
    ProjectEntityListActions.delete_entity_fail,
    (state, error): ProjectEntityListState => ({
      ...state,
      actionError: 'delete',
      actionErrorData: error,
      projectEntityListLoading: false
    })
  ),
  on(
    ProjectEntityListActions.copy_entity_fail,
    (state, error): ProjectEntityListState => ({
      ...state,
      actionError: 'copy',
      actionErrorData: error,
      projectEntityListLoading: false
    })
  ),
  on(
    ProjectEntityListActions.import_xml_fail,
    (state, error): ProjectEntityListState => ({
      ...state,
      actionError: 'import',
      actionErrorData: error,
      projectEntityListLoading: false
    })
  ),
  // Paging and filters
  on(
    ProjectEntityListActions.change_paging,
    (state: ProjectEntityListState, data): ProjectEntityListState => ({
      ...state,
      page: data.page,
      pageSize: data.pageSize
    })
  ),

  on(
    ProjectEntityListActions.change_filter,
    (state: ProjectEntityListState, data): ProjectEntityListState => ({
      ...state,
      searchPhrase: data.searchPhrase,
      onlyMine: data.onlyMine
    })
  )
);
